function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z",
  fill: "#201D1A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.995 6v4.245c0 .209.072.386.218.531a.722.722 0 00.53.219h4.246v6.243a.722.722 0 01-.218.53.723.723 0 01-.53.22H7.748a.72.72 0 01-.53-.22.72.72 0 01-.219-.53V6.75a.72.72 0 01.219-.53.72.72 0 01.53-.219h4.246zm.999.023c.426.078.77.247 1.03.508l2.435 2.435c.26.26.429.603.507 1.03h-3.972zm1.997 9.717a.247.247 0 01-.07.18.244.244 0 01-.18.07H9.249a.247.247 0 01-.18-.07.247.247 0 01-.07-.18v-.5c0-.073.023-.133.07-.18a.247.247 0 01.18-.07h5.494c.073 0 .133.024.18.07.046.047.07.107.07.18v.5zm0-1.998a.245.245 0 01-.07.18.244.244 0 01-.18.07H9.249a.247.247 0 01-.18-.07.245.245 0 01-.07-.18v-.5c0-.073.023-.132.07-.18a.247.247 0 01.18-.07h5.494c.073 0 .133.024.18.07.046.048.07.107.07.18v.5z"
});

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.ccc009e5.svg";
export { ForwardRef as ReactComponent };